// Status copy for the hero match-night card.
// A night fires at minToFire and extra players run a second match, so seats
// are never actually scarce — the card counts toward the threshold and never
// claims a night is full.

export const OVER_THRESHOLD_NOTE = "Still open. Extra players run a second match.";

export function formatMatchNightStatus({
  confirmedCount = 0,
  minToFire,
  isToday = false,
} = {}) {
  if (typeof minToFire !== "number" || !Number.isFinite(minToFire) || minToFire < 1) {
    return null;
  }

  const confirmed = Math.max(0, Number(confirmedCount) || 0);
  const threshold = Math.floor(minToFire);

  if (confirmed >= threshold) {
    return {
      label: `Match night is ON · ${confirmed} confirmed`,
      note: OVER_THRESHOLD_NOTE,
    };
  }

  const needed = threshold - confirmed;
  const tonight = isToday ? " tonight" : "";

  return {
    label: confirmed === 0
      ? `${needed} needed to start${tonight}`
      : `${needed} more needed to start${tonight}`,
    note: null,
  };
}
